import { configureStore, combineReducers } from '@reduxjs/toolkit';
import loadingReducer from '../../application/features/common/loadingSlice';
import userSlice from '../features/users/userSlice';
import proposalReducer from '../features/proposal/proposalSlice';
import proposalDocsReducer from '../features/proposalDocument/proposalDocumentSlice';
import chatReducer from '../features/chat/chatSlice';
import authReducer from '../features/auth/authSlice';
import companyReducer from '../features/company/companySlice';
import expertiseReducer from '../features/expertise/expertiseSlice';
import knowledgeBaseReducer from '../features/knowledgeBase/knowledgeBaseSlice';
const combinedReducers = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    users: userSlice,
    proposal: proposalReducer,
    company: companyReducer,
    proposalDocs: proposalDocsReducer,
    chat: chatReducer,
    expertise: expertiseReducer,
    knowledgeBase: knowledgeBaseReducer
});
const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
};
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore Blob values in Redux state for PDF document handling
            ignoredActions: ['proposalDocs/getDocById/fulfilled'],
            ignoredPaths: ['proposalDocs.documentPdf']
        }
    })
});
